import { gql } from "@apollo/client";

export const GET_ATTACHED_MODULE_INTEGRATIONS = gql`
  query GetAttachedModuleIntegrations($moduleId: ID!) {
    module(id: $moduleId) {
      integrations {
        awsV2 {
          id
          read
          write
          durationSeconds
          externalId
          name
          roleArn
          integrationId
          isAutoattached
          labels
        }
        azure {
          id
          read
          write
          defaultSubscriptionId
          subscriptionId
          integrationName
          integrationId
          isAutoattached
          labels
        }
      }
    }
  }
`;
